import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { globalStyle } from "../../global/Utils";

// Back, on a report page: to wherever the user came from - the Reports tab,
// or the Buyers list for a ledger opened from a buyer's row. A page opened
// straight from its address (a bookmark, a new tab) has nowhere in the app to
// go back to, so it goes to the Reports tab instead.
export const ReportBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const goBack = () =>
    location.key === "default" ? navigate("/main/reports") : navigate(-1);

  return (
    <button
      type="button"
      onClick={goBack}
      className="inline-flex items-center gap-1 mb-3 px-3 py-1.5 rounded-md border border-gray-400 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-100 transition-colors"
      style={{ fontFamily: globalStyle.fontFamilyButton }}
    >
      <ArrowBackIcon fontSize="small" />
      Back
    </button>
  );
};
